import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import finvuLogo from '../../assets/finvuLogoNew.png';
import loaderStyles from "./Loader.styles";

const Loader = () => {
  return (
    <Grid 
      container
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Redirecting to Finvu Account Aggregator"
      sx={{
        ...loaderStyles.container,
      }}
    >
      <img
        alt="Finvu Logo"
        src={"/assets/finvuLogoNew.png"}
        style={{ width: '109px', marginTop: '15px' }}
      />

      <Typography 
        sx={{ 
          ...loaderStyles.loadingText,
        }}
      >
        Redirecting to Finvu Account Aggregator...
      </Typography>

      <Box
        sx={{
          ...loaderStyles.loadingBar,
        }}
      />

      <Typography
        sx={{
          ...loaderStyles.footerText,
        }}
      >
        Please don't refresh or close the tab
      </Typography>
    </Grid>
  );
};

export default Loader;